import React from 'react'
import './MobileNavBar.style.scss'

const BlurBackground = ({ open }) => {
  return <div className={`visible-screen ${open ? 'active' : ''}`}></div>
}

export default BlurBackground
